import L from 'leaflet'

const icon_ecoponto_azul = new L.Icon({
    iconUrl: require('assets/img/icons/ecoponto-azul.png'),
    iconRetinaUrl: require('assets/img/icons/ecoponto-azul.png')        
});

const icon_planotrabalho_azul = new L.Icon({
    iconUrl: require('assets/img/icons/planotrabalho-azul.png'),
    iconRetinaUrl: require('assets/img/icons/planotrabalho-azul.png')        
});

const icon_avulso_azul = new L.Icon({
    iconUrl: require('assets/img/icons/avulso-azul.png'),
    iconRetinaUrl: require('assets/img/icons/avulso-azul.png')        
});

const icon_ecoponto_cinza = new L.Icon({
    iconUrl: require('assets/img/icons/ecoponto-cinza.png'),
    iconRetinaUrl: require('assets/img/icons/ecoponto-cinza.png')        
});

const icon_planotrabalho_cinza = new L.Icon({
    iconUrl: require('assets/img/icons/planotrabalho-cinza.png'),
    iconRetinaUrl: require('assets/img/icons/planotrabalho-cinza.png')        
});

const icon_avulso_cinza = new L.Icon({
    iconUrl: require('assets/img/icons/avulso-cinza.png'),
    iconRetinaUrl: require('assets/img/icons/avulso-cinza.png')        
});

const icon_destino = new L.Icon({
    iconUrl: require('assets/img/icons/marker-destination.png'),
    iconSize: [28,33],
    iconRetinaUrl: require('assets/img/icons/marker-destination.png')        
});

const icon_unload = new L.Icon({
    iconUrl: require('assets/img/icons/marker-unload.png'),
    iconSize: [28,33],
    iconRetinaUrl: require('assets/img/icons/marker-unload.png')        
});


export {
    icon_ecoponto_azul, 
    icon_planotrabalho_azul,
    icon_avulso_azul,
    icon_ecoponto_cinza,
    icon_planotrabalho_cinza,
    icon_avulso_cinza,
    icon_destino,
    icon_unload
}